import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

import { reskinTokens } from './reskinning';

const { light, dark } = tokens.color.theme;

export const getLightTheme = () => ({
  color: reskinTokens(light),
});

export const getDarkTheme = () => ({
  color: reskinTokens(dark),
});

export const getDefaultTheme = getLightTheme;
